import { OrderType } from '../../types/order/orderType';

export const orderTypesWhenPriceRequired: OrderType[] = [
  OrderType.StopLimit,
  OrderType.Limit,
  OrderType.Oco,
  OrderType.Iceberg,
];

export const orderTypesWhenStopActivationPriceRequired: OrderType[] = [
  OrderType.StopLimit,
  OrderType.StopMarket,
  OrderType.Oco,
  OrderType.Iceberg,
];

export const marketOrderTypes: OrderType[] = [OrderType.Market, OrderType.StopMarket];
